import React from 'react';
import { Provider } from 'react-redux';
import { TranslationsProvider } from 'arag-ui-lib';
import { store, persistor } from './store/store';
import MainRouter from './routers/mainRouter';
import './assets/styles/uiLibOverwrites.css';
import ErrorBoundary from './components/general/errorBoundary/errorBoundary';
import { PersistGate } from 'redux-persist/integration/react';
import i18n from './i18n/i18n';
import { QueryClient, QueryClientProvider } from 'react-query';

function App() {
    const queryClientConfig: any = {
        defaultOptions: {
            queries: {
                retry: 1,
                staleTime: 'Infinity',
                refetchOnMount: true,
                refetchOnWindowFocus: false,
                refetchOnReconnect: 'false',
            },
        },
    };
    const queryClient: QueryClient = new QueryClient(queryClientConfig);
    return (
        <TranslationsProvider i18n={i18n}>
            <ErrorBoundary>
                <Provider store={store}>
                    <PersistGate persistor={persistor}>
                        <QueryClientProvider client={queryClient}>
                            <MainRouter />
                        </QueryClientProvider>
                    </PersistGate>
                </Provider>
            </ErrorBoundary>
        </TranslationsProvider>
    );
}

export default App;
